/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import AuthLayout from '../components/common/AuthLayout';
import Signup from '../components/common/Signup';
import ScrollingColumn from '../components/common/ScrollingColumn';

const SignupPage = () => {
	return (
		<AuthLayout
			left={<Signup />}
			right={
				<>
					<ScrollingColumn direction="up" />
					<ScrollingColumn direction="down" />
					<ScrollingColumn direction="up" />
				</>
			}
		/>
	);
};

export default SignupPage;
